import React from 'react';

import Translate from '../../../../utils/Translate';
import { EmailStore } from '../../../../state/EmailStore';
import { PersonalInfoStore } from '../../../../state/PersonalInfoStore';
import { UserAndBalance } from './Companion/UserAndBalance';
import { User } from './Companion/User';

import { getLoyaltyLogoByTier } from '../common/commonLoyalty';

import './MergeTiersAndPoints.css';
import '../common/common-loyalty.css';

import { LoyaltyPoints } from '../common/LoyaltyPoints';

export const MergeTiersAndPoints = () => {
  const oldUser = new User(PersonalInfoStore.name, PersonalInfoStore.getPrimaryEmail());
  const oldUserAndBalance = new UserAndBalance(oldUser, EmailStore.getLoyaltyOldUserBalance());

  const newUser = new User(PersonalInfoStore.name, EmailStore.getMergeableEmail());
  const newUserAndBalance = new UserAndBalance(newUser, EmailStore.getLoyaltyNewUserBalance());

  const userAndBalanceList = [oldUserAndBalance, newUserAndBalance];

  return (
    <div className="tiers-and-points-container">
      {userAndBalanceList.map(({ user, balance }, index) => {
        const tierCode = balance && balance.tier.code;

        return balance &&
          <div key={index} className={`tiers-and-points ${tierCode && `-${tierCode}`}`}>
            <div className="loyalty-user-info">
              <div className="user-name-container">
                <img src={getLoyaltyLogoByTier(balance.tier.code)} alt={balance.tier.name}/>
                {user.name && <span className="user-name">{user.name}</span>}
              </div>
              <div className="passport-tier-name">
                <span>{Translate.message('Pasaporte').toUpperCase()} {balance.tier.name}</span>
              </div>
              <div className="-eva-3-mt-sm">
                <span className="user-email">{user.email}</span>
              </div>
            </div>
            <LoyaltyPoints
              availablePoints={balance.availablePoints}
              pendingPoints={balance.pendingPoints}
            />
          </div>;
      })
      }
    </div>
  );
};
